/**
 * Constants for EditUserModal select options
 */

// Industry options (common industries)
export const INDUSTRY_OPTIONS = [
  { value: 'Agriculture', label: 'Agriculture' },
  { value: 'Automotive', label: 'Automotive' },
  { value: 'Construction', label: 'Construction' },
  { value: 'Food & Beverage', label: 'Food & Beverage' },
  { value: 'Healthcare', label: 'Healthcare' },
  { value: 'Manufacturing', label: 'Manufacturing' },
  { value: 'Retail', label: 'Retail' },
  { value: 'Technology', label: 'Technology' },
  { value: 'Transportation', label: 'Transportation' },
  { value: 'Wholesale', label: 'Wholesale' },
];

// Role options
export const ROLE_OPTIONS = [
  { value: 'CFO', label: 'CFO' },
  { value: 'CONTROLLER', label: 'Controller' },
  { value: 'CREDIT_MANAGER', label: 'Credit Manager' },
  { value: 'FINANCE_DIRECTOR', label: 'Finance Director' },
  { value: 'TREASURER', label: 'Treasurer' },
  { value: 'CEO', label: 'CEO' },
  { value: 'PRESIDENT', label: 'President' },
  { value: 'OWNER_FOUNDER', label: 'Owner/Founder' },
  { value: 'ACCOUNTING', label: 'Accounting' },
  { value: 'BOOKKEEPER', label: 'Bookkeeper' },
  { value: 'ACCOUNTS_RECEIVABLE', label: 'Accounts Receivable' },
  { value: 'OFFICE_MANAGER', label: 'Office Manager' },
  { value: 'OTHER', label: 'Other' },
];

// Country options are now loaded dynamically from world-countries package
// See utils/countryOptions.ts for implementation

// Language/Locale options are now loaded dynamically from the API
// See hooks/useLocales.ts for implementation

// Type for select option
export interface SelectOption {
  value: string;
  label: string;
}
